module.exports = __webpack_public_path__ + "8ad44cf1382f9ef541e00a455f9e16e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./src/img/demo/heatmap.jpg
// module id = 1828
// module chunks = 0